import React from "react";
import "./download.scss";
import Navbar from "../../components/Navbar/navbar";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/footer";

const DownloadPage = () => {
  return (
    <>
    <Navbar />
    <section className="hero">
      <div className="hero__content">
        <h1>Connect Anonymously</h1>
        <p>Try it yourself. Download now.</p>
        <div className="hero__buttons">
          <Link to="https://apps.apple.com/us/app/orter/id6751794873" className="store-btn apple"><FaApple /> <p>Download on the <br /><span>App Store</span></p></Link>
          <Link to="https://play.google.com/store/apps/details?id=com.orter&pcampaignid=web_share" className="store-btn google"><FaGooglePlay /> <p>Get it on <br /><span>Google Play</span></p></Link>
        </div>
      </div>

      <div className="hero__image">
        <img src='https://res.cloudinary.com/dsnontai6/image/upload/v1758998698/Orter/undraw_friends-online_gvwz_gyprc0.svg' alt="App preview" />
      </div>
    </section>
    <Footer />
    </>
  );
};

export default DownloadPage;
